import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";
import { ReadModeCount } from "./readModeCountDTO";
import { MachineType } from './machineType';

//this model is used to define the analysis details

export class Analysis{
    
    _id: string;
    analysisName:string;
    versionOfAnalysis:string;
    lab:LabMDM; 
    pipelineName:string;
    sequencer:string;
    product:boolean;
    productId:string;
    mismatch:boolean;
    limsUpload:boolean;
    autoAnalysis:boolean;
    reanalysis:boolean;
    indexAnalysis:boolean;
    ignoreMissingFile:boolean;
    active:boolean;
    history:OperetionHistoryDTO[];
    
}